import { createSelector } from "@ngrx/store";
import { AppState } from "../app.state";
import { OauthAccessToken } from "../../models/oauth/oauth-access-token";
import { environment } from "../../../environments/environment";

export const selectAuthOauthFeatureState = (state: AppState) => state.authOauthReducer;

export const selectOauthCodeVerifierValue = createSelector(
  selectAuthOauthFeatureState,
  (oauthState) => oauthState?.oauthCodeVerifier?.value ?? ""
);

export const selectOauthStaterValue = createSelector(
  selectAuthOauthFeatureState,
  (oauthState) => oauthState?.oauthState?.value ?? ""
);

export const selectOauthTokenValue = createSelector(
  selectAuthOauthFeatureState,
  (oauthState) => oauthState.oauthToken
);

export const selectOauthAccessTokenValue = createSelector(
  selectOauthTokenValue,
  (oauthToken) => oauthToken?.accessToken ?? ""
);

export const selectOauthRefreshTokenValue = createSelector(
  selectOauthTokenValue,
  (oauthToken) => oauthToken?.refreshToken ?? ""
);

export const selectOauthAccessTokenObject = createSelector(
  selectOauthAccessTokenValue,
  (oauthToken) => {
    try {
      return oauthToken ? new OauthAccessToken(oauthToken) : null
    } catch {
      return null
    }
  }
);

export const selectIsOauthTokenValid = createSelector(
  selectOauthAccessTokenObject,
  selectOauthRefreshTokenValue,
  (accessToken, refreshToken) => {
    // console.log("getting current token ", accessToken);
    if (environment.name == "DEV") return true;
    return !!accessToken &&
      !!refreshToken &&
      !accessToken.isTokenExpired();
  }
);

export const selectFirstNameFromToken = createSelector(
  selectOauthAccessTokenObject,
  (oauthToken) => oauthToken?.firstName ?? ""
);


export const selectLastSigninTimestampFromToken = createSelector(
  selectOauthAccessTokenObject,
  (oauthToken) => oauthToken?.getLastLoginDate() ?? null
);
